import { render, staticRenderFns } from "./test-record.vue?vue&type=template&id=25c8fa62&scoped=true"
import script from "./test-record.vue?vue&type=script&lang=js"
export * from "./test-record.vue?vue&type=script&lang=js"
import style0 from "./test-record.vue?vue&type=style&index=0&id=25c8fa62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8fa62",
  null
  
)

export default component.exports